import {
  composeClassNames,
  ifDefined,
  withDefault,
} from "@faedev/editor-utils";
import { CSSProperties, ReactElement, ReactNode } from "react";
import Translate from "src/components/Translate";
import getDifficultyIcon from "src/functions/getDifficultyIcon";
import Body_back from "src/icons/Body-back";
import Check from "src/icons/Check";
import Duration from "src/icons/Duration";
import Eye from "src/icons/Eye";
import Lungs from "src/icons/Lungs";
import Target from "src/icons/Target";
import Warrior from "src/icons/Warrior";
import Yoga from "src/icons/Yoga";
import Yogamat from "src/icons/Yogamat";
import { sProperty } from "src/styles/sProperty.module.scss";
import { VariantProperty } from "src/types/VariantProperty";
import { VariantSize } from "src/types/VariantSize";

type Props = {
  size?: VariantSize | null | undefined;
  className?: (string | string) | null | undefined;
  style?: CSSProperties | null | undefined;
  type?: VariantProperty | null | undefined;
  showIcon?: boolean | null | undefined;
  showLabel?: boolean | null | undefined;
  translation?: boolean | null | undefined;
  value: ReactElement | string | number | boolean | ReactNode[];
};

function Property({
  size,
  className,
  style,
  type,
  showIcon,
  showLabel,
  translation,
  value,
}: Props) {
  return ifDefined(
    value,
    (valueDefined) =>
      valueDefined ? (
        <div
          className={composeClassNames([
            sProperty,
            withDefault(size, `nm`),
            className,
            "property",
            showIcon ? "has-icon" : "",
          ])}
          style={style}
        >
          {ifDefined(
            showIcon,
            (hideIconDefined) =>
              hideIconDefined ? (
                <div className={"property-icon"}>
                  {(function () {
                    switch (type) {
                      case `body_part`:
                        return <Body_back />;
                      case `breathing`:
                        return <Lungs />;
                      case `country`:
                        return null;
                      case `difficulty`:
                        return getDifficultyIcon(
                          (function () {
                            switch (value) {
                              case `beginner`:
                                return `beginner`;
                              case `moderate`:
                                return `moderate`;
                              case `intermediate`:
                                return `intermediate`;
                              case `advanced`:
                                return `advanced`;
                            }
                          })()
                        );
                      case `duration`:
                        return <Duration />;
                      case `equipment`:
                        return <Yogamat />;
                      case `focus`:
                        return <Target />;
                      case `followers`:
                        return null;
                      case `movement`:
                        return <Warrior />;
                      case `skill`:
                        return <Warrior />;
                      case `status`:
                        return null;
                      case `style`:
                        return <Yoga />;
                      case `verified`:
                        return <Check />;
                      case `views`:
                        return <Eye />;
                    }
                  })()}
                </div>
              ) : null,
            () => null
          )}
          {ifDefined(
            showLabel,
            (showLabelDefined) =>
              showLabelDefined ? (
                <div className={"property-label"}>
                  {(function () {
                    switch (type) {
                      case `body_part`:
                        return <Translate tKey={`Body part`} />;
                      case `breathing`:
                        return <Translate tKey={`Breathing`} />;
                      case `country`:
                        return <Translate tKey={`Country`} />;
                      case `difficulty`:
                        return <Translate tKey={`Difficulty`} />;
                      case `duration`:
                        return <Translate tKey={`Duration`} />;
                      case `equipment`:
                        return <Translate tKey={`Equipment`} />;
                      case `focus`:
                        return <Translate tKey={`Focus`} />;
                      case `followers`:
                        return <Translate tKey={`Followers`} />;
                      case `movement`:
                        return <Translate tKey={`Movement type`} />;
                      case `skill`:
                        return <Translate tKey={`Skill`} />;
                      case `status`:
                        return <Translate tKey={`Status`} />;
                      case `style`:
                        return <Translate tKey={`Style`} />;
                      case `verified`:
                        return <Translate tKey={`Verified`} />;
                      case `views`:
                        return <Translate tKey={`Views`} />;
                    }
                  })()}
                </div>
              ) : null,
            () => null
          )}
          <div className={"property-value"}>
            {translation ? <Translate tKey={String(value)} /> : value}
          </div>
        </div>
      ) : null,
    () => null
  );
}

export default Property;
